import { useResponsive } from "@design-lab/shared/hooks/useResponsive";
import { Tooltip, TooltipContent, TooltipTrigger } from "@design-lab/shared/ui/tooltip";
import { type ReactNode } from "react";

type AIDesignTooltipProps = {
  onClose: () => void;
  isOpen: boolean;
  children: ReactNode;
};

export function AIDesignTooltip({ onClose, isOpen, children }: AIDesignTooltipProps) {
  const { isDesktop } = useResponsive();

  return (
    <Tooltip
      open={isOpen}
      onOpenChange={open => {
        if (!open) {
          onClose();
        }
      }}
    >
      <TooltipTrigger asChild data-testid="ai-design-tooltip-trigger">
        <div>{children}</div>
      </TooltipTrigger>
      <TooltipContent
        side={isDesktop ? "right" : "bottom"}
        onClose={onClose}
        className="text-background w-[280px] rounded-lg bg-blue-700 text-sm"
        arrowClassName="fill-blue-700 bg-blue-700"
        data-testid="ai-design-tooltip-content"
      >
        Try our AI Design tool to instantly generate unique artworks and explore new creative ideas.
      </TooltipContent>
    </Tooltip>
  );
}
